import type { TourDefinition } from '../../types/tour';

export const workspacesSettingsFirstTour: TourDefinition = {
  key: 'workspaces_settings_first',
  title: 'ワークスペース設定ツアー',
  steps: [
    {
      target: '#workspaces-table',
      title: 'ワークスペース管理',
      content:
        'ここでワークスペースの作成・編集・削除ができます。各行のアクションから操作してください。',
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '#set-default-action',
      title: 'メイン切替',
      content:
        '★ アイコンをクリックすると、ログイン直後に表示されるメインワークスペースを切り替えできます。',
      placement: 'left',
    },
  ],
};
